module.exports = __webpack_public_path__ + "files/f3cc4da1ae9371150a3cb56bd469e561.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/filesOverlay.png
 ** module id = 810
 ** module chunks = 0
 **/